/*
 * @Author: 
 * @Date: 2022-08-01 17:15:23
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-03 13:24:16
 * @FilePath: /Cup2Supplier/Users/onepisya/Documents/GitHub/jdhl_work/Cup2Market/src/utils/auth.js
 * @Description: 
 */
// import Cookies from "js-cookie";
import browserType from "./browserTypeAdapter";

const TokenKey = "cup2market_token";

export function getToken() {
  return localStorage.getItem(TokenKey)
  // return Cookies.get(TokenKey);
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token);
  // return Cookies.set(TokenKey, token);
}

export function removeToken() {
  // return Cookies.remove(TokenKey);
  return localStorage.removeItem(TokenKey)
}

export function isWechat() {
  return browserType() === "weixin"
}
